import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMakeReportOrderMutation , useFetchAvailablePaymentQuery, useFetchExtraSettingQuery} from '../../app/feature/API/Helpers';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { useGetProfileQuery } from '../../app/feature/API/Profile';

const CartTable = () => {
  const { t, i18n } = useTranslation();
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [removingItems, setRemovingItems] = useState([]); 
  const { data: availablePayment } = useFetchAvailablePaymentQuery();
  const [loadingPaymentId, setLoadingPaymentId] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [banqueMisrModalOpen, setBanqueMisrModalOpen] = useState(false);
  const [banqueMisrHtml, setBanqueMisrHtml] = useState("");
  const { data: ProfileData } = useGetProfileQuery();
    const { data } = useFetchExtraSettingQuery();
  const base_currency_symbol = data?.extra?.map((e)=>e?.base_currency_symbol)
  const base_currency_rate = data?.extra?.map((e)=>e?.base_currency_rate)
  const toggleModal = () => {
    if (ProfileData?.subscribe_status === 0) {
      setModalOpen(!modalOpen);
    } else {
      handleCheckout(""); 
      return;
    }
  };
    useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartItems(storedItems);
    calculateTotal(storedItems);
  }, []);

  const calculateTotal = (items) => {
    // const total = items.reduce((acc, item) => acc + parseFloat(item.current_price) || 0, 0);
    const total = items.reduce((acc, item) => acc + (parseFloat(item.current_price) || 0), 0) * base_currency_rate;
    setTotalPrice(total);
  };

  const handleRemove = (slug) => {
    setRemovingItems([...removingItems, slug]); 
    setTimeout(() => { 
      const updatedItems = cartItems.filter((item) => item.slug !== slug);
      setCartItems(updatedItems);
      localStorage.setItem('cartItems', JSON.stringify(updatedItems));
      calculateTotal(updatedItems);
    }, 300); 
  };

  const [makeReportOrder , {isLoading}] = useMakeReportOrderMutation();

  const handleCheckout = async (gateway) => {
    if (cartItems.length === 0) {
      toast.error(i18n.language === 'en' ? 
        "Your cart is empty, can't proceed with checkout." : 
        "العربة فارغة، لا يمكن إتمام الشراء.");
      return;
    }
  
    if (loadingPaymentId) {
      toast.warning(i18n.language === 'en' ? "Please wait, processing..." : "من فضلك انتظر، يتم المعالجة...");
      return;
    }
  
    const itemIds = cartItems.map((item) => item.id);
    setLoadingPaymentId(gateway); 
  
    try {
      const response = await makeReportOrder({ ids: itemIds, gateway }).unwrap();  
      if (gateway === "banquemisr") {
        if(response?.html){
          const parser = new DOMParser();
          const doc = parser.parseFromString(response?.html, "text/html");
          const extractedHtml = doc.documentElement.innerHTML;
  
          if (extractedHtml) {
            setBanqueMisrHtml(extractedHtml);
            setBanqueMisrModalOpen(true);
          } else {
            return;
          }
        }
        else{
          if(response?.payment_url){
            window.open(response.payment_url, "_blank");
          }
          else{
            return;
          }
        }
      } else {
        if (response?.payment_url) {
          window.open(response.payment_url, "_blank");
        } else {
          return;
        }
      }
  
      toast.success(response.message || (i18n.language === 'en' ? "Done!" : "تم!"));
      localStorage.removeItem('cartItems');
      setRemovingItems(cartItems.map(item => item.slug));
  
      setTimeout(() => {
        setCartItems([]); 
        setTotalPrice(0); 
      }, 300);
  
    } catch (error) {
      console.error('Failed to submit order:', error);
      toast.error(i18n.language === 'en' ? "Failed to submit order." : "فشل في إرسال الطلب.");
    } finally {
      setLoadingPaymentId(null); 
    }
  };
  
  

  return (
    <section className='content-block-wrapper section-padding bg-white fix'>
      <div className="container">
        <div className="dashboard-header">
          <div className="head-info">
            <p>
              {i18n.language === 'en' ? 'Total Items' : 'إجمالي العناصر'} : <span>{cartItems.length}</span>
            </p>
          </div>
          <div className="head-info">
            <p>{i18n.language === 'en' ? 'Total Price' : 'إجمالي السعر'} : <span>{base_currency_symbol} {totalPrice.toFixed(2)}</span></p>
            <div id="tableinfo"></div>
          </div>
        </div>
        <div className="table-responsive custom-table">
          {cartItems.length > 0 ? (
            <table className="table table-stripe datatable">
              <thead className="thead-light">
                <tr>
                  <th>{i18n.language === 'en' ? 'Reports' : 'التقارير'}</th>
                  <th>{i18n.language === 'en' ? 'Price' : 'السعر'}</th>
                  <th>{i18n.language === 'en' ? 'Remove' : 'حذف'}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((item) => (
                  <tr key={item.slug} className={removingItems.includes(item.slug) ? 'fade-out' : ''}>
                    <td>
                      <h2 className="table-avatar d-flex align-items-center">
                        <a href="javascript:void(0)" className="avatar">
                          <img src={item.feature_image} className="rounded" alt="Report Image" />
                        </a>
                        <a href="javascript:void(0);" className="text-dark">{item.title}</a>
                      </h2>
                    </td>
<td>
  {base_currency_symbol} {" "}
  {(parseFloat(item.current_price) * base_currency_rate).toFixed(2)}
</td>
                    <td>
                      <div className="table-action">
                        <a href="javascript:void(0);" onClick={() => handleRemove(item.slug)}>
                          <i className="fa fa-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className='p-5 text-center fs-1'>{i18n.language === 'en' ? 'Your cart is empty' : 'العربة فارغة'}</p>
          )}
        </div>
        <div className="col-md-12 col-12 d-flex justify-content-end" style={{marginTop:'15px'}}>
          <button
            className="theme-btn me-sm-4 wow fadeInLeft btn-explore"
            type="button" 
            onClick={toggleModal}
          >
          {isLoading? (
          <>
            {t("loading")} 
            <i className="fa fa-spinner fa-spin" /> 
          </>
          ) : (
          <>
            {i18n.language === 'en' ? "Checkout" : "إتمام الشراء"}
          </>
          )}

          </button>
        </div>
      </div>
      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>
          {t("choose_payment_method")}
        </ModalHeader>
        <ModalBody style={{display:"flex",gap:'7px'}}>
          {availablePayment?.length > 0 ? (
            availablePayment.map((payment) => (
              <Button
  key={payment.keyword}
  color="primary"
  className="w-100"
  style={{ height: "60px", borderRadius: "6px" }}
  onClick={() => handleCheckout(payment.keyword)}
  disabled={loadingPaymentId === payment.keyword} 
>
  {loadingPaymentId === payment.keyword ? (
    <>
      {t("processing")}
      <i className="fa fa-spinner fa-spin ml-2" />
    </>
  ) : (
    payment.name
  )}
</Button>
            ))
          ) : (
            <p className="text-center">{t("No_Data")}</p>
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={banqueMisrModalOpen}
        toggle={() => setBanqueMisrModalOpen(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setBanqueMisrModalOpen(false)}>
          {t("banque_misr_payment")}
        </ModalHeader>
        <ModalBody style={{ height: "80vh" }}>
          <iframe
            title="Banque Misr Payment"
            srcDoc={banqueMisrHtml}
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </ModalBody>
      </Modal>
    </section>
  );
};

export default CartTable;